import loadable from '@loadable/component';

const applyConfig = (config) => {
  config.settings = {
    ...config.settings,
    matomoSiteId: 'EDqeLwypGg',
    matomoUrlBase: 'https://ingestion.webanalytics.italia.it/',

    externalRoutes: [
      ...config.settings.externalRoutes,
      { match: { path: '/itinerari' } },
    ],

    italiaThemeViewsConfig: {
      ...config.settings.italiaThemeViewsConfig,
      imagePosition: 'documentBody', // possible values: afterHeader, documentBody
    },

    siteProperties: {
      ...config.settings.siteProperties,
      siteTitle: undefined,
      siteSubtitle: undefined,
      subsiteParentSiteTitle: undefined,
      parentSiteTitle: 'Regione Emilia-Romagna',
      parentSiteURL: 'https://www.regione.emilia-romagna.it/',
    },

    //SUBTITLES
    loadables: {
      ...config.settings.loadables,
      'subsite-yellow': loadable.lib(() =>
        import('ucman-theme/subsites/yellow'),
      ),
      'subsite-light-blue': loadable.lib(() =>
        import('ucman-theme/subsites/light-blue'),
      ),
    },
  };

  config.settings['volto-gdpr-privacy'].defaultPanelConfig = null;

  return config;
};

export default applyConfig;
